import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from './usersettings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
var moment = require('moment');
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { CommonFunction } from '../main/CommonFunction';
import { Subscription } from 'rxjs';
import { CustomDateFormat } from './CustomDateFormat';
import { DatePipe } from '@angular/common';
import { Console } from 'console';

@Component({
    selector: 'product-ledger-template',
    template: require('./CommonProductLedgerTemplate.html'),
    styles: [``]
})

export class CommonProductLedgerTemplateComponent implements OnInit, OnDestroy {
    @Input('productname') Product_Name: any;
    @Input('productid') Product_ID: any;
    @Input('LedgerFromDate') LedgerFromDate: any;
    @Input('LedgerTodate') LedgerTodate: any;
    @Input("dValue") dvalue: any;

    static parameters = [UtilityService, HttpClient, NgbModal, HotkeysService, BsDatepickerConfig, CommonFunction, CustomDateFormat, DatePipe]
    bsConfig: any;
    busy: Subscription;
    public overlayNoRowsTemplate: any;
    public isBottomBarActivated: boolean = true;
    toastWarningMsg(msg) {
        this.toast({ type: 'warning', title: msg });
    }

    constructor(public utilityService: UtilityService, public http: HttpClient, private modalService: NgbModal, private hotkeysService: HotkeysService, public _bsDatepickerConfig: BsDatepickerConfig, public commonFunction: CommonFunction, public customDateFormat: CustomDateFormat, public datePipe: DatePipe) {
        this.http = http;
        this.modalService = modalService;
        this.hotkeysService = hotkeysService;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: this.unitInfo.dateInputFormat, containerClass: this.unitInfo.dateColorTheme });
        this._bsDatepickerConfig.dateInputFormat = this.unitInfo.dateInputFormat;

        this.defaultColDef = {
            resizable: true,
        };

        $(document).ready(function () {
            setTimeout(() => {
                var header = $('product-ledger-template .modal-header').height();
                var body = $('product-ledger-template').parent().height();
                var ledgerSummHeight = $('product-ledger-template .modal-body .ledgerSumm').height();
                var bottomBar = $('product-ledger-template .modal-body #toggleBottomBar').height();
                var appHeight = body - header - ledgerSummHeight - bottomBar + 'px !important';
                $('product-ledger-template .modal-body .table-responsive.ledger').attr('style', 'height:' + appHeight);
            }, 100);
        })
    }
    ngOnDestroy(): void {
        // this.hotkeysService.remove(this.hotkeyList);
        // if(this.modalService.hasOpenModals()){
        //     this.modalService.dismissAll();
        // }
    }
    gridHeight: any;
    ledgerrowData: any;
    gridApiLedger: any;
    gridColumnApiLedger: any;
    paginationConf: any;
    d: any;
    defaultColDef: any;
    rowSelectionSingle: string;
    searchValue: any;
    unitInfo: any;
    ledgercolumnDefs: any;
    ledgerSearch: any;
    modalReference: NgbModalRef;
    public overlayLoadingTemplate: any;
    public hotkeyList: Hotkey[];
    ledgerrowData_EntryType: any;
    ledgerrowData_BatchNo: any;
    ledgerfooterData: any;
    ledgerrowData_full: any;
    ledgerRowSelected: any;
    ProductbatchList1: any;
    ProductvendorList: any;
    ProductcustomerList: any;
    ProductbatchList: any;
    ProductEntryList: any;
    public lastSearchObject: any;
    public SalesmanList: any = [];
    selectedLedgerDetails: any={};
    userUnitList: any;
    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        // backdrop: `rgba(30, 30, 37, 0.4)`
    });

    ngOnInit(): void {
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.overlayNoRowsTemplate = "<h4> No record to show. </h4>";
        this.paginationConf = UserSettings.enablePagination;
        var header = $('product-ledger-template .modal-header').height();
        var body = $('product-ledger-template').parent().height();
        this.gridHeight = body - header;
        const numberSort = (num1: number, num2: number) => {
            return num1 - num2;
        };
        this.ledgercolumnDefs = [
            { headerName: 'Entry Type', field: 'Entry_Type', width: 120 },
            { headerName: 'Doc Date', field: 'Doc_Date', width: 120 },
            { headerName: 'Doc No', field: 'Doc_No', width: 120 },
            { headerName: 'Ref. Doc Date', field: 'Ref_Doc_Date', width: 100 },
            { headerName: 'Ref. Doc No', field: 'Ref_Doc_No', width: 100 },
            { headerName: 'Code', field: 'Party_Code' , width: 90},
            { headerName: 'Particulars', field: 'Particular', width: 180 },
            { headerName: 'City', field: 'City', width: 100 },
            { headerName: 'Batch No', field: 'Batch_No', width: 90 },
            { headerName: 'MRP', field: 'MRP', width: 90 },
            { headerName: 'PTS', field: 'PTS', width: 90 },
            { headerName: 'PTR', field: 'PTR', width: 90 },
            { headerName: 'S.Rate', field: 'SRate', width: 90},
            { headerName: 'In Qty', field: 'IN_ENTRY_Qty', width: 100, cellStyle: { 'textAlign': "right" } },
            { headerName: 'In Free', field: 'IN_FREE_Qty', width: 100, cellStyle: { 'textAlign': "right" } },
            { headerName: 'In R.Qty', field: 'R_Qty', width: 100, cellStyle: { 'textAlign': "right" } },
            { headerName: 'Out Qty', field: 'OUT_ENTRY_Qty', width: 100, cellStyle: { 'textAlign': "right" } },
            { headerName: 'Out Free', field: 'OUT_FREE_Qty', width: 100, cellStyle: { 'textAlign': "right" } },
            { headerName: 'Bal Qty', field: 'Balance', width: 100, cellStyle: { 'textAlign': "right" } },
            { headerName: 'Warehouse', field: 'Warehouse_Code', width: 100 },
             { headerName: 'Salesman', field: 'Salesman', width: 100 },
            { headerName: 'Unit Name', field: 'Unit_Name', width: 150 },
        ];

        this.initHotkeys();
        this.initModalQuery();
        setTimeout(() => {
            $("#From_Date").focus();
        }, 200);
        this.ledgerSearch = {};
        this.ledgerSearch.From_Date = this.oneMonthAgo();
        this.ledgerSearch.To_Date = new Date();
        this.ledgerSearch.filtertype = 'B';
        this.ledgerSearch.Unit_ID = this.unitInfo.Unit_ID;
        this.ledgerrowData = [];
        this.ProductbatchList1 = [];
        this.ledgerfooterData = [];
        this.lastSearchObject = {};
        this.selectedLedgerDetails.purchaseDetails={
            Inward_Type: '',
            Inward_No: '',
            Inward_Date: '',
            Vendor_Code: '',
            Vendor_Name: '',
            Vendor_Bill_No: '',
            Vendor_Bill_Date: '',
            In_Qty: 0,
            In_Free_Qty: 0,
            In_Sch_Per: 0,
            Sale_Scheme: 0,
            Sale_Scheme_Per: 0,
            ref_Po_No: ''
        };
        this.selectedLedgerDetails.salesDetails = {
            Dispatch_No: '',
            Dispatch_Date: '',
            ED_Order_No: '',
            Ref_Order_No: '',
            Issue_Discount_Per: '',
            Issue_Scheme_Per: '',
            Issue_Tax_Per: '',
        };
        this.selectedLedgerDetails.salesReturnDetails={
            Invoice_No:'', Invoice_Date:'', Discount_Per:'', Sales_Scheme:''
        }
        this.overlayLoadingTemplate = "<div class='loader2'>" +
            "<div class='loading'><img src='public/loader-icon-2.svg'></div>" +
            "</div>";

        this.ledgerSearch.GTflag = true;
        setTimeout(() => {
            if (this.LedgerFromDate) {
                this.ledgerSearch.From_Date = new Date(this.LedgerFromDate);
                this.ledgerSearch.To_Date = new Date(this.LedgerTodate);

            } else {
                this.ledgerSearch.From_Date = this.oneMonthAgo();
                this.ledgerSearch.To_Date = new Date();
            }
            this.GetProductLedgerDetails();
            this.Get_Customer_Vendor_Batch_Product_Wise();

            $('.ponotab').hide();
        }, 100);
        this.getUserUnitList().then((unitList) => {
            this.userUnitList = unitList;
        })
    }

    initHotkeys() {
        this.hotkeyList = [];

        let ctrls = new Hotkey('alt+u', (event: KeyboardEvent): boolean => {
            this.ledgerSearch.filtertype = 'S';
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrls);
        this.hotkeysService.add(ctrls);

        let ctrlc = new Hotkey('alt+c', (event: KeyboardEvent): boolean => {
            this.ledgerSearch.filtertype = 'C';
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlc);
        this.hotkeysService.add(ctrlc);

        let ctrlb = new Hotkey('alt+b', (event: KeyboardEvent): boolean => {
            this.ledgerSearch.filtertype = 'B';
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlb);
        this.hotkeysService.add(ctrlb);

        let ctrlo = new Hotkey('alt+o', (event: KeyboardEvent): boolean => {
            $('.ledger-modal-popup #okbtn').trigger('click');
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlo);
        this.hotkeysService.add(ctrlo);

        let ctrle = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
            $('.ledger-modal-popup #excelbtn').trigger('click');
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrle);
        this.hotkeysService.add(ctrle);

        let ctrld = new Hotkey('alt+d', (event: KeyboardEvent): boolean => {
            if ($('.ledger-modal-popup').is(':visible')) {
                // Toggle the summary panel
                console.log('ledger-modal-popup');
                // $('#toggleBottomBarBTN').trigger('click');
                this.toggleBottomBarFn();
                return false;
            } else {
                event.preventDefault();
            }
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrld);
        this.hotkeysService.add(ctrld);
    }

    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }

    initModalQuery() {
        var parent = this;
        $('.ledger-form input[role=combobox], .ledger-form').on('keypress', function (e) {
            if (e.which == 13) {
                e.preventDefault();
                var attr = $(this).attr('role');
                if (attr == 'combobox') {
                    var res = $(this).parents(".customNgSelect").map(function () {
                        return this;
                    }).get();
                    var index = Number($(res).attr("datafocus")) + 1;
                } else {
                    var index = Number($(this).attr("datafocus")) + 1;
                }
                var $next = $('[datafocus=' + index + ']');
                var tagName = $($next).prop("tagName");
                if (!$next.length) {
                    if ($('form[name="form"]').hasClass('ng-invalid')) {
                        var all = $("form[name=form] ng-select.ng-invalid, form[name=form] input.ng-invalid, form[name=form] select.ng-invalid, form[name=form] textarea.ng-invalid");
                        if ($(all[0]).prop("tagName") == 'NG-SELECT') {
                            var focusId = $(all[0]).attr('id');
                            var focusIdElem = '#' + focusId + ' input[role=combobox]';
                            $(focusIdElem).focus().select();
                        } else {
                            $(all[0]).focus();
                        }
                        var errorAttr = $(all[0]).attr('data-error');
                        parent.toastWarningMsg(errorAttr);
                    } else {
                        $('.ledger-modal-popup #okbtn').click();
                    }
                } else if (tagName == 'NG-SELECT') {
                    var elemId = '';
                    var focusElem = '';
                    if (parent.ledgerSearch.filtertype == 'S') {
                        elemId = 'Vendor_ID';
                        focusElem = '#' + elemId + ' input[role=combobox]';
                    } else if (parent.ledgerSearch.filtertype == 'C') {
                        elemId = 'Customer_ID';
                        focusElem = '#' + elemId + ' input[role=combobox]';
                    } else {
                        elemId = 'Other_party';
                        focusElem = '#' + elemId;
                    }
                    $(focusElem).focus().select();
                } else {
                    $next.focus().select();
                }
            }
        });
    }

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    f_chkNum(p_value) {
        var Val = Number(p_value);
        if (Val) {
            return Val;
        }
        return 0;
    }

    Get_Customer_Vendor_Batch_Product_Wise() {
        let AllUnit = this.f_chkNum(this.ledgerSearch.Unit_ID) == 0 ? 1 : 0;
        var data = {
            "Product_ID": this.Product_ID,
            "Unit_ID": this.f_chkNum(this.ledgerSearch.Unit_ID),
            "Company_ID": this.unitInfo.Company_ID,
            "Entry_Type": this.f_chkNum(this.ledgerSearch.Transaction_Type),
            "From_Date": moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD'),
            "To_Date": moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD'),
            "AllUnit": AllUnit
        };
        this.http.post(`/api/${this.unitInfo.Company_Code}/products/Get_Customer_Vendor_Batch_Product_Wise`, data)
            .subscribe((res: any) => {
                this.ProductvendorList = res["VendorData"];
                this.ProductcustomerList = res["CustomerData"];
                this.ProductbatchList = res["BatchData"];
                this.ProductEntryList = res["EntryData"];
            });
    }

    GetProductLedgerDetails() {
        if (!this.ledgerSearch.From_Date) {
            this.toastWarningMsg("From Date cannot be blank");
            return false;
        }
        if (!this.ledgerSearch.To_Date) {
            this.toastWarningMsg("To Date cannot be blank");
            return false;
        }
        if (this.ledgerSearch.To_Date < this.ledgerSearch.From_Date) {
            this.toastWarningMsg("To Date cannot be less than From Date");
            return false;
        }

        let AllUnit = this.f_chkNum(this.ledgerSearch.Unit_ID) == 0 ? 1 : 0;
        var data = {
            "Product_ID": this.Product_ID,
            "Entry_Type": (this.ledgerSearch.Transaction_Type ? this.ledgerSearch.Transaction_Type : 0),
            "Batch_ID": (this.ledgerSearch.Batch_ID ? this.ledgerSearch.Batch_ID : 0),
            "Unit_ID": this.f_chkNum(this.ledgerSearch.Unit_ID),
            "Company_ID": this.unitInfo.Company_ID,
            "From_Date": moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD'),
            "To_Date": moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD'),
            "filtertype": this.ledgerSearch.filtertype,
            "Party_ID": this.f_chkNum(this.ledgerSearch.Party_ID),
            "Salesman_ID": this.f_chkNum(this.ledgerSearch.Salesman_ID),
            "AllUnit": AllUnit
        };
        this.busy = this.http.post(`/api/${this.unitInfo.Company_Code}/products/Get_Ledger_Product_Wise`, data)
            .subscribe((res: any) => {
                for (var i = 0; i < res.ledgerData.length; i++) {
                    if (res.ledgerData[i].Transaction_Type == 15) {
                        res.ledgerData[i].Particular = "Stock adjustment";
                    } else if (res.ledgerData[i].Transaction_Type == 22) {
                        res.ledgerData[i].Particular = "Godown Transfer";
                    } else if (res.ledgerData[i].Transaction_Type == 24) {
                        res.ledgerData[i].Particular = "Godown expiry";
                    }
                }
                this.ledgerrowData = res.ledgerData;
                this.ledgerrowData_full = res.ledgerData;
                this.ledgerfooterData = res.ledgerFooterData;
                this.GetProductDetailsExcludeGT();
                this.Get_Customer_Vendor_Batch_Product_Wise();
                this.ledgerrowData_EntryType = this.findUnique(res.ledgerData, d => d.Entry_Type);

                if (this.lastSearchObject.From_Date != this.ledgerSearch.From_Date || this.lastSearchObject.To_Date != this.ledgerSearch.To_Date) {
                    this.SalesmanList = this.findUnique(res.ledgerData.filter(item =>  item.Salesman_ID > 0), d => d.Salesman_ID);
                }
                this.lastSearchObject.From_Date = this.ledgerSearch.From_Date;
                this.lastSearchObject.To_Date = this.ledgerSearch.To_Date;

                if (this.ledgerrowData.length > 0) {
                    setTimeout(() => {
                        this.gridApiLedger.getModel().getRow(0).setSelected(true);
                        this.gridApiLedger.setFocusedCell(0, "Doc_No");
                        this.gridApiLedger.sizeColumnsToFit();
                    }, 500);
                }else{
                    setTimeout(() => {
                        this.gridApiLedger.sizeColumnsToFit();
                    }, 500);
                }
            })
    }

    batchDetail() {
        this.ProductbatchList1 = [];
        let AllUnit = this.f_chkNum(this.ledgerSearch.Unit_ID) == 0 ? 1 : 0;
        var data = {
            Product_ID: this.Product_ID,
            "Unit_ID": this.f_chkNum(this.ledgerSearch.Unit_ID),
            Company_ID: this.unitInfo.Company_ID,
            Entry_Type: this.f_chkNum(this.ledgerSearch.Transaction_Type),
            From_Date: moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD'),
            To_Date: moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD'),
            "AllUnit": AllUnit
        };

        this.http.post(`/api/${this.unitInfo.Company_Code}/products/Get_Customer_Vendor_Batch_Product_Wise`, data)
            .subscribe(response => {
                var res = [];
                res.push(response);
                this.ProductbatchList1 = res[0]["BatchData"];
            });
    }

    GetProductDetailsExcludeGT() {
        let TotalLedgerData = {
            "Entry_Type": "Total Count :",
            "Doc_Date": "0",
            "Particular" : "Total :",
            "IN_Qty": 0,
            "IN_ENTRY_Qty": 0,
            "IN_FREE_Qty": 0,
            "OUT_ENTRY_Qty": 0,
            "OUT_FREE_Qty": 0,
            "R_Qty":0,
            "Balance": 0
        };
        var parent = this;
        if (this.ledgerSearch.GTflag == true) {
            this.ledgerrowData = this.ledgerrowData.filter(obj => {
                return obj.Transaction_Type != 22
            });
        } else {
            this.ledgerrowData = this.ledgerrowData_full;
        }

        TotalLedgerData.Doc_Date = this.ledgerrowData.length;

        TotalLedgerData.IN_Qty = (this.ledgerrowData.reduce(function (acc, sum) {
            return acc + parseFloat(sum.IN_Qty)
        }, 0));
        TotalLedgerData.IN_ENTRY_Qty = (this.ledgerrowData.reduce(function (acc, sum) {
            return acc + parseFloat(sum.IN_ENTRY_Qty)
        }, 0));
        TotalLedgerData.IN_FREE_Qty = (this.ledgerrowData.reduce(function (acc, sum) {
            return acc + parseFloat(sum.IN_FREE_Qty)
        }, 0));
        TotalLedgerData.OUT_ENTRY_Qty = (this.ledgerrowData.reduce(function (acc, sum) {
            return acc + parseFloat(sum.OUT_ENTRY_Qty)
        }, 0));
        TotalLedgerData.OUT_FREE_Qty = (this.ledgerrowData.reduce(function (acc, sum) {
            return acc + parseFloat(sum.OUT_FREE_Qty)
        }, 0));
        TotalLedgerData.R_Qty = (this.ledgerrowData.reduce(function (acc, sum) {
            return acc + parseFloat(sum.R_Qty)
        }, 0));
        TotalLedgerData.Balance = (this.ledgerfooterData.reduce(function (acc, sum) {
            return acc + parseFloat(sum.Close_Qty)
        }, 0));

        /* TotalLedgerData.OUT_ENTRY_Qty = (this.ledgerfooterData.reduce(function (acc, sum) {
            return acc + parseFloat(sum.OUT_ENTRY_Qty)
        }, 0)); */

        setTimeout(() => {
            this.gridApiLedger.setPinnedBottomRowData([TotalLedgerData])
        }, 300);
    }

    findUnique(arr, predicate) {
        var found = {};
        arr.forEach(d => {
            found[predicate(d)] = d;
        });
        return Object.keys(found).map(key => found[key]);
    }

    ledgeronSelectionChanged() {
        var selectedRows = this.gridApiLedger.getSelectedRows();
        this.ledgerRowSelected = selectedRows[0];
        // console.log(this.ledgerRowSelected);
        // console.log("isBottomBarActivated:", this.isBottomBarActivated);
        if (this.isBottomBarActivated == true && [6,9,16,2].includes(this.ledgerRowSelected.Transaction_Type)) {
            this.getLedgerSummery();
        } else {
            this.hideSummaryPannel();
        }
        /*  this.gridApiLedger.getModel().getRow(0).setSelected(true);
         this.gridApiLedger.setFocusedCell(0, "Doc_No"); */
    }

     hideSummaryPannel() {
        $('.info.ledgerSumm').hide();
        let ledgerSummHeight = $('product-ledger-template .modal-body .ledgerSumm').height();
        let bottomBar = $('product-ledger-template .modal-body #toggleBottomBar').height();
        let size: number = ledgerSummHeight + bottomBar;
        console.log("hideSummaryPannel:"+size);
        $('product-ledger-template .modal-body .table-responsive.ledger').attr('style', 'height:' + size + 'px !important');
    }
    showSummaryPannel() {
        $('.info.ledgerSumm').show();
        if(this.ledgerRowSelected.Transaction_Type == 6){
            $('.ponotab').show();
        }else{
            $('.ponotab').hide();
        }
        var ledgerSummHeight = $('product-ledger-template .modal-body .ledgerSumm').height();
        var bottomBar = $('product-ledger-template .modal-body #toggleBottomBar').height();
        let size: number = this.gridHeight - ledgerSummHeight - bottomBar - 50;
        console.log("showSummaryPannel:" + size);
        $('product-ledger-template .modal-body .table-responsive.ledger').attr('style', 'height:' + size + 'px !important');
    }

    private getLedgerSummery() {
        const payload = {
            "Batch_ID": this.ledgerRowSelected.Batch_ID, "Transaction_Line_No": this.ledgerRowSelected.Transaction_Line_No,
            "Transaction_Type": this.ledgerRowSelected.Transaction_Type,
        };
        this.busy = this.http.post(`/api/${this.unitInfo.Company_Code}/products/getProductLedgerDetails`, payload)
            .subscribe((res: any) => {
                this.selectedLedgerDetails.purchaseDetails = res.purchaseDetails[0];
                this.selectedLedgerDetails.salesDetails = res.salesDetails[0];
                this.selectedLedgerDetails.salesReturnDetails = res.salesreturnDetails[0]
                this.showSummaryPannel();
            });
    }

     

    ledgeronGridReady(params) {
        this.gridApiLedger = params.api;
        this.gridColumnApiLedger = params.columnApi;
        var myInput = document.getElementById("ledgermodalag");
        let self = this;
        myInput.addEventListener("keydown", function (event) {
            if (event.keyCode == 8) {
                setTimeout(() => {
                    if (self.ledgerSearch.filtertype == 'B') {
                        $('.ledger-form #From_Date').focus();
                    } else {
                        $('.ledger-form .customNgSelect input[role=combobox]').focus();
                    }
                }, 200);
            }
        });
    }

    oneMonthAgo() {
        var monthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );
        return monthAgo;
    }

    NavigateScreen(event) {
        let parent = this;

        if (event.keyCode == 13 || event.type == "rowDoubleClicked") {
            let focusedCell = this.gridApiLedger.getFocusedCell();
            if (focusedCell && focusedCell.column["colDef"]["field"] == "Doc_No") {
                let TransNo = 0;
                let TransType = 0;
                let Particular = 0;
                let Doc_Date = '';
                if (event.data) {
                    TransNo = this.f_chkNum(event.data.Transaction_No);
                    TransType = this.f_chkNum(event.data.Transaction_Type);
                    Doc_Date = event.data.Doc_Date;
                } else {
                    let selectedRows = this.gridApiLedger.getSelectedRows();
                    TransNo = this.f_chkNum(selectedRows[0].Transaction_No);
                    TransType = this.f_chkNum(selectedRows[0].Transaction_Type);
                    Doc_Date = selectedRows[0].Doc_Date;
                }
                //return;
                if (TransNo > 0) {
                    let data_navi = { "ScreenType": TransType, "Transaction_No": TransNo, "Transaction_Date": Doc_Date }
                    parent.commonFunction.Nevigate_Document_Entry(data_navi);
                }
            }
        }
    }

    exportExcelLedger() {
        let To_Date = moment(this.ledgerSearch.To_Date).format('DD-MMM-YYYY');
        let From_Date = moment(this.ledgerSearch.From_Date).format('DD-MMM-YYYY');
        let d = new Date();
        let row = this.unitInfo.Company_Name + '\n' + this.unitInfo.Company_Full_Address + '\n' + 'Product Name : ' + this.Product_Name + '\n' + 'From : ' + From_Date + ',' + 'To : ' + To_Date;
        var fName = 'Ledger_' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            customHeader: row,
            fileName: fName,
        };
        this.gridApiLedger.exportDataAsCsv(params);
    }
    toggleBottomBarFn(){
        if(this.ledgerRowSelected == undefined){
            return false;
        }
        if([6,9,16].includes(this.ledgerRowSelected.Transaction_Type) && this.isBottomBarActivated==false ){
            this.isBottomBarActivated = true;
          
            this.getLedgerSummery();
            let size: number = this.gridHeight - 280;
            // $('product-ledger-template .modal-body .table-responsive.ledger').attr('style', 'height:' + size + 'px !important');
        }else{
            this.isBottomBarActivated = false;
            this.hideSummaryPannel();
            // $('.info.ledgerSumm').hide();
            // var ledgerSummHeight = $('product-ledger-template .modal-body .ledgerSumm').height();
            // var bottomBar = $('product-ledger-template .modal-body #toggleBottomBar').height();
            // let size: number = this.gridHeight - ledgerSummHeight + bottomBar;
            // $('product-ledger-template .modal-body .table-responsive.ledger').attr('style', 'height:' + size + 'px !important');
        }
        console.log("ledgerRowSelected:", this.ledgerRowSelected);
        console.log("isBottomBarActivated:", this.isBottomBarActivated);
    }

    DateChange(type){
        if(type == 'D'){
            if (this.LedgerFromDate) {
                this.ledgerSearch.From_Date = new Date(this.LedgerFromDate);
                this.ledgerSearch.To_Date = new Date(this.LedgerTodate);
            } else {
                this.ledgerSearch.From_Date = this.oneMonthAgo();
                this.ledgerSearch.To_Date = new Date();
            }
        }
        
        if(type == 'B'){
            const tempfromDate = new Date(this.ledgerSearch.From_Date);
            let newDate_1 = new Date(tempfromDate.setMonth(tempfromDate.getMonth() - 1));
            let from_date = new Date(newDate_1.getFullYear(), newDate_1.getMonth(), 1);        
            let to_date = new Date(from_date.getFullYear(), from_date.getMonth() + 1, 0);
            this.ledgerSearch.From_Date = from_date;
            this.ledgerSearch.To_Date = to_date;
        }
        
        if(type == 'F'){
            const tempendDate = new Date(this.ledgerSearch.To_Date);
            let newDate_1 = new Date(tempendDate.setMonth(tempendDate.getMonth() + 1));
            let from_date = new Date(newDate_1.getFullYear(), newDate_1.getMonth(), 1);
            let to_date = new Date(from_date.getFullYear(), from_date.getMonth() + 1, 0);
            this.ledgerSearch.From_Date = from_date;
            this.ledgerSearch.To_Date = to_date;
        }

        this.GetProductLedgerDetails();
    }

    async getUserUnitList(): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
            let payload = {
                user_ID: this.unitInfo._id,
            };
            this.http.post('/api/users/getUnitData', payload)
                .subscribe((response: any) => {
                    if (response && response.UnitList) {
                        resolve(response.UnitList || []);
                    } else {
                        resolve([]);
                    }
                })
        })
    }
}
